/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout';
var schoolRouter = [{
  path: '/',
  name: 'workbenchschool',
  component: Layout,
  children: [{
    path: 'workbenchschool',
    component: function component() {
      return import('@/views/gov/workbenchschool');
    },
    meta: {
      title: '工作台',
      icon: 'home',
      roles: ['schooladmin', 'schooldoctor']
    }
  }]
}, {
  path: '/',
  name: 'schooldatareport',
  component: Layout,
  meta: {
    title: '数据分析',
    icon: 'nav_data',
    roles: ['schooladmin', 'schooldoctor']
  },
  children: [{
    path: 'indexvision',
    component: function component() {
      return import('@/views/school/report/indexvision');
    },
    meta: {
      title: '视力分析'
    }
  }, {
    path: 'indexillness',
    component: function component() {
      return import('@/views/school/report/indexillness');
    },
    meta: {
      title: '常见病分析'
    }
  }
  // {
  //   path: 'indexinspection',
  //   component: () => import('@/views/school/report/indexinspection'),
  //   meta: { title: '行为影响因素监测', },
  // },
  ]
},
// 传染病监测
{
  path: "/gov/pestilently",
  name: "pestilently",
  component: Layout,
  meta: {
    title: "传染病监测",
    icon: "nav_pes",
    roles: ['schooladmin']
  },
  children: [{
    path: "management",
    component: function component() {
      return import("@/views/school/checks/district/management");
    },
    meta: {
      title: "晨午检报告",
      roles: ["schooladmin"]
    }
  }, {
    path: "statisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis");
    },
    meta: {
      title: " 健康状况查询 ",
      roles: ["schooladmin"]
    }
  }]
},
// region 健康干预工作
{
  path: "/gov/healthily-work",
  name: "gydataanalysis-ai",
  component: Layout,
  meta: {
    title: "健康干预工作",
    icon: "nav_sys",
    roles: ["schooladmin"]
  },
  children: [{
    path: "gysetting",
    component: function component() {
      return import("@/views/gov/gywork/gySetting");
    },
    meta: {
      title: "健康干预工作设置"
    }
  }, {
    path: "gyfile",
    component: function component() {
      return import("@/views/gov/gywork/gyFile");
    },
    meta: {
      title: "健康干预档案管理"
    }
  }, {
    path: "gyinform",
    component: function component() {
      return import("@/views/gov/gywork/gyInform");
    },
    meta: {
      title: "AI预警通知设置"
    }
  }, {
    path: "sub",
    component: function component() {
      return import("@/views/gov/gywork/components/gySub");
    },
    hidden: true,
    meta: {
      title: "订阅相关"
    }
  }, {
    path: "inform",
    component: function component() {
      return import("@/views/gov/gywork/components/gyInform");
    },
    hidden: true,
    meta: {
      title: "推送与通知"
    }
  }, {
    path: "ques",
    component: function component() {
      return import("@/views/gov/gywork/components/gyQues");
    },
    hidden: true,
    meta: {
      title: "调查问卷"
    }
  }, {
    path: "sight",
    component: function component() {
      return import("@/views/gov/gywork/components/gySight");
    },
    hidden: true,
    meta: {
      title: "视力自测与监测"
    }
  }]
}, {
  path: '/workbenchgarde',
  component: Layout,
  children: [{
    path: '',
    component: function component() {
      return import('@/views/gov/workbenchgarde');
    },
    meta: {
      title: '工作台',
      icon: 'nav_workbench',
      roles: ['schoolgrade', 'schoolclazz']
    }
  }]
}, {
  path: '/',
  name: 'gradeatareport',
  component: Layout,
  meta: {
    title: '数据分析',
    icon: 'nav_data',
    roles: ['schoolgrade', 'schoolclazz']
  },
  children: [{
    path: 'indexvision',
    component: function component() {
      return import('@/views/school/report/indexvision');
    },
    meta: {
      title: '视力分析'
    }
  }, {
    path: 'indexillness',
    component: function component() {
      return import('@/views/school/report/indexillness');
    },
    meta: {
      title: '常见病分析'
    }
  }]
},
// 近视干预
{
  path: "/school/healthily",
  name: "gydataanalysis-schooladmin",
  component: Layout,
  alwaysShow: true,
  meta: {
    title: "健康干预",
    icon: "nav_sys",
    roles: ["schooladmin"]
  },
  children: [{
    path: "schoolsta",
    component: function component() {
      return import("@/views/gov/functionally/interfere/dataStatistics");
    },
    meta: {
      title: "近视干预统计"
    }
  }]
},
// 功能分类
{
  path: '/school/functionally',
  name: 'functionallys',
  component: Layout,
  meta: {
    title: '常用功能',
    icon: 'nav_functive',
    roles: ['schooladmin', 'schooldoctor', 'schoolgrade', 'schoolclazz']
  },
  children: [{
    path: 'schoolmsg',
    component: function component() {
      return import('@/views/school/information/schoolmsg');
    },
    meta: {
      title: '学校信息管理',
      roles: ['schooladmin', "schooldoctor"]
    }
  }, {
    path: 'screencompany',
    component: function component() {
      return import('@/views/school/screencompany');
    },
    meta: {
      title: '筛查单位信息',
      roles: ['schooladmin', 'schooldoctor']
    }
  }, {
    path: 'accountmanage',
    component: function component() {
      return import('@/views/school/functionally/progress');
    },
    meta: {
      title: '账号管理',
      roles: ['schooladmin']
    }
  }, {
    path: 'schoolmanage',
    component: function component() {
      return import('@/views/school/manage');
    },
    meta: {
      title: '筛查管理',
      roles: ['schooladmin', "schooldoctor", "schoolgrade", "schoolclazz"]
    }
  }, {
    path: 'assess',
    component: function component() {
      return import('@/views/screen/assess/assessschool');
    },
    meta: {
      title: '质量控制',
      roles: ['schooladmin', 'schooldoctor']
    }
  }, {
    path: 'schoolexport',
    component: function component() {
      return import('@/views/school/manage/export');
    },
    meta: {
      title: '导出数据',
      roles: ['schooladmin']
    }
  }, {
    path: 'schoolStatisticAnalysis',
    component: function component() {
      return import('@/views/school/statisticAnalysis/school');
    },
    meta: {
      title: '健康状况查询',
      roles: ['schooladmin']
    }
  }, {
    path: 'message',
    component: function component() {
      return import('@/views/school/notify');
    },
    meta: {
      title: '消息中心',
      roles: ['schooladmin', "schooldoctor"]
    }
  }, {
    path: 'operationlog',
    component: function component() {
      return import('@/views/gov/operationlog');
    },
    meta: {
      title: '操作日志',
      roles: ['schooladmin', 'schooldoctor', "schoolgrade", "schoolclazz"]
    }
  }, {
    path: 'plan',
    component: function component() {
      return import('@/views/school/manage/plan');
    },
    hidden: true,
    meta: {
      title: '筛查计划管理',
      roles: ['schooladmin']
    }
  }, {
    path: 'file',
    component: function component() {
      return import('@/views/school/manage/file');
    },
    hidden: true,
    meta: {
      title: '学生档案管理',
      roles: ['schooladmin', 'schooldoctor', 'schoolgrade', 'schoolclazz']
    }
  }, {
    path: 'grade',
    component: function component() {
      return import('@/views/school/information/grade');
    },
    meta: {
      title: '班级信息管理',
      roles: ['schoolclazz', "schoolgrade"]
    }
  }, {
    path: "classStatisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis/class");
    },
    hidden: true,
    meta: {
      title: " 健康状况查询 ",
      roles: ["schooladmin"]
    }
  },
  // {
  //   path: "management",
  //   component: () => import("@/views/school/checks/schooldoctor/management"),
  //   meta: { title: "晨午检上报", roles: ['schooldoctor'] }
  // },
  // {
  //   path: "attendanceManage",
  //   component: () => import("@/views/school/checks/schooldoctor/attendanceManage"),
  //   meta: { title: "考勤管理" , roles: ['schooldoctor']}
  // },
  // {
  //   path: "earlyWarningProcessing",
  //   component: () => import("@/views/school/checks/schooldoctor/earlyWarningProcessing"),
  //   meta: { title: "预警处理" , roles: ['schooldoctor']}
  // },

  // {
  //   path: 'questionnairestatistics',
  //   component: () => import('@/views/school/information/questionnairestatistics'),
  //   meta: { title: '调查问卷统计', roles: ['schoolgrade'] }
  // },
  {
    path: "helpcenter",
    component: function component() {
      return import("@/views/screen/helpcenter");
    },
    meta: {
      title: "帮助中心",
      roles: ["schooladmin", "schooldoctor", "schoolgrade", "schoolclazz"]
    }
  }
  // {
  //   path: 'infectiousWarning',
  //   component: () => import('@/views/school/infectiousWarning'),
  //   meta: { title: '疫情预警', roles: ['schooladmin'] }
  // },
  ]
}, {
  path: '/school/account',
  name: 'schoolaccount',
  hidden: true,
  component: Layout,
  meta: {
    title: '账号分配',
    icon: 'account',
    roles: ['schooladmin']
  },
  children: [{
    path: 'screener',
    component: function component() {
      return import('@/views/school/account/screener');
    },
    meta: {
      title: '筛查员账号管理'
    }
  }, {
    path: 'schooldoctor',
    component: function component() {
      return import('@/views/school/account/schooldoctor');
    },
    meta: {
      title: '校医账号分配'
    }
  }, {
    path: 'gradeDirector',
    component: function component() {
      return import('@/views/school/account/gradeDirector');
    },
    meta: {
      title: '年级主任账号分配'
    }
  }, {
    path: 'headmaster',
    component: function component() {
      return import('@/views/school/account/headmaster');
    },
    meta: {
      title: '班主任账号分配'
    }
  }]
},
// {
//   path: '/school/file',
//   component: Layout,
//   meta: { roles: ['schooladmin'] },
//   children: [
//     {
//       path: '',
//       name: 'file',
//       component: () => import('@/views/school/file'),
//       meta: { title: '学生档案管理', icon: 'ope' },
//     }
//   ]
// },
// {
//   path: '/school/plan',
//   component: Layout,
//   meta: { roles: ['schooladmin'] },
//   children: [
//     {
//       path: '',
//       name: 'plan',
//       component: () => import('@/views/school/manage/plan'),
//       meta: { title: '筛查计划管理', icon: 'ope' },
//     }
//   ]
// },

{
  path: '/school/manage',
  name: 'manage',
  hidden: true,
  component: Layout,
  meta: {
    title: '筛查管理',
    icon: 'ope',
    roles: ['schooladmin']
  },
  children: [{
    path: 'plan',
    component: function component() {
      return import('@/views/school/manage/plan');
    },
    meta: {
      title: '筛查计划管理'
    }
  }, {
    path: 'file',
    component: function component() {
      return import('@/views/school/manage/file');
    },
    meta: {
      title: '学生档案管理'
    }
  },
  // {
  //   path: 'assess',
  //   component: () => import('@/views/school/manage/assess'),
  //   meta: { title: '质量控制' }
  // },
  {
    path: 'export',
    component: function component() {
      return import('@/views/school/manage/export');
    },
    meta: {
      title: '下载文件'
    }
  }, {
    path: 'assess',
    component: function component() {
      return import('@/views/screen/assess/index');
    },
    meta: {
      title: '质量控制'
    }
  }]
}, {
  path: '/school/screencompany',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'screencompany',
    component: function component() {
      return import('@/views/school/screencompany');
    },
    meta: {
      title: '筛查单位信息',
      icon: 'company',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/notify',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'notify',
    component: function component() {
      return import('@/views/school/notify');
    },
    meta: {
      title: '重要通知',
      icon: 'notify',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/studentinfo',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'studentinfo',
    component: function component() {
      return import('@/views/school/studentinfo');
    },
    meta: {
      title: '监测详情',
      icon: 'studentinfo',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/studentinfoanalyse',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'studentinfoanalyse',
    component: function component() {
      return import('@/views/school/studentinfoanalyse');
    },
    meta: {
      title: '全校监测详情',
      icon: 'studentinfoanalyse',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/studentinfoanalysegarde',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'studentinfoanalysegarde',
    component: function component() {
      return import('@/views/school/studentinfoanalysegarde');
    },
    meta: {
      title: '年级监测详情',
      icon: 'studentinfoanalysegarde',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/studentinfoanalyseclass',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'studentinfoanalyseclass',
    component: function component() {
      return import('@/views/school/studentinfoanalyseclass');
    },
    meta: {
      title: '班级监测详情',
      icon: 'studentinfoanalyseclass',
      roles: ['schooladmin']
    }
  }]
}, {
  path: '/school/roport',
  name: 'roport',
  component: Layout,
  hidden: true,
  meta: {
    title: '数据分析',
    icon: 'report',
    roles: ['schooladmin']
  },
  children: [{
    path: 'school',
    component: function component() {
      return import('@/views/school/report/school');
    },
    meta: {
      title: '全校数据分析'
    }
  }, {
    path: 'grade',
    component: function component() {
      return import('@/views/school/report/grade');
    },
    meta: {
      title: '年级数据分析'
    }
  }, {
    path: 'class',
    component: function component() {
      return import('@/views/school/report/class');
    },
    meta: {
      title: '班级数据分析'
    }
  }, {
    path: 'workbenchschooltotal',
    hidden: true,
    component: function component() {
      return import('@/views/gov/report/workbenchschooltotal');
    },
    meta: {
      title: '数据分析'
    }
  }]
}, {
  path: '/school/personal',
  meta: {
    roles: ['schooladmin']
  },
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'personal',
    component: function component() {
      return import('@/views/gov/personal');
    },
    meta: {
      title: '个案数据分析',
      icon: 'people'
    }
  }]
}, {
  path: '/school/operationlog',
  meta: {
    roles: ['schooladmin']
  },
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'operationlog',
    component: function component() {
      return import('@/views/gov/operationlog');
    },
    meta: {
      title: '操作日志',
      icon: 'operationlog'
    }
  }]
}
// {
//   path: '/school/information',
//   name: 'information',
//   component: Layout,
//   meta: { title: '信息管理', icon: 'message', roles: ['schooladmin'] },
//   children: [
//     {
//       path: 'school',
//       component: () => import('@/views/school/information/school'),
//       meta: { title: '学校信息管理' }
//     },
//     {
//       path: 'grade',
//       component: () => import('@/views/school/information/grade'),
//       meta: { title: '班级信息管理' }
//     },
//   ]
// },
];
export default schoolRouter;